import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { PaymentMethods } from './PaymentMethods';
import { CheckCircle2, ShieldCheck, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-16 md:pt-24 md:pb-24 overflow-hidden bg-gradient-to-b from-ballet-100 to-ballet-50" data-id="element-102">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <h1 className="md:text-5xl lg:text-6xl font-serif font-bold text-charcoal mb-8 text-balance text-[28px]" data-id="element-105">
            Tutto il tuo Anno di Lezioni di Ballet{' '}
            <span className="text-ballet-600 italic" data-id="element-106">Risolto</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.15
      }} className="relative max-w-2xl mx-auto mb-8" data-id="element-107">
          <div className="absolute inset-0 bg-ballet-300 rounded-full blur-3xl opacity-20 transform translate-y-8" data-id="element-108"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qRUr72tDbVYVVK58pivG1S/ChatGPT_Image_27_jun_2026,_00_02_22-Photoroom.png" alt="Ballet Pronto Box Set" className="relative z-10 w-4/5 h-auto mx-auto drop-shadow-2xl" data-id="element-109" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} data-id="element-110">
          <p className="md:text-2xl font-medium text-charcoal-light mb-4 text-[14px]" data-id="element-111">
            Ballet Pronto™ Box Set Completo 7 Volumi + 5 Bonus
          </p>

          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-112">
            Il tuo sistema completo di insegnamento del ballet già pronto:
            fondamenti tecnici, esercizi alla sbarra, costruzione delle lezioni,
            coreografie, programmi di progressione e fidelizzazione.{' '}
            <strong className="text-charcoal" data-id="element-113">
              Senza improvvisare mai più.
            </strong>
          </p>

          <div className="flex flex-row flex-nowrap items-center justify-center gap-1.5 sm:gap-3 mb-8 text-[11px] sm:text-sm text-gray-600 whitespace-nowrap" data-id="element-114">
            <span className="flex items-center" data-id="element-115">
              <CheckCircle2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-ballet-500 mr-1" data-id="element-116" />
              PDF Digitale
            </span>
            <span className="text-gray-300" data-id="element-117">•</span>
            <span className="flex items-center" data-id="element-118">
              <Zap className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-ballet-500 mr-1" data-id="element-119" />
              Accesso Immediato
            </span>
            <span className="text-gray-300" data-id="element-120">•</span>
            <span className="flex items-center" data-id="element-121">
              <CheckCircle2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-ballet-500 mr-1" data-id="element-122" />
              Tutti i Livelli
            </span>
          </div>

          <div className="space-y-4" data-id="element-123">
            <Button onClick={() => window.location.href = 'https://ballet-pronto.impultienda.ar/checkout'} fullWidth className="md:w-auto text-lg" data-id="element-124">
              🚀 SÌ, VOGLIO IL MIO BALLET PRONTO™ ORA
            </Button>

            <PaymentMethods className="pt-2" data-id="element-125" />

            <div className="flex items-center justify-center gap-6 text-sm text-gray-500 font-medium" data-id="element-126">
              <div className="flex items-center" data-id="element-127">
                <ShieldCheck className="w-4 h-4 mr-1 text-green-600" data-id="element-128" />
                Garanzia 7 giorni
              </div>
              <div className="flex items-center" data-id="element-129">
                <ShieldCheck className="w-4 h-4 mr-1 text-green-600" data-id="element-130" />
                Pagamento Sicuro
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}